import { cleanup, concatenateWavFiles } from './concatenate-wav-files';

/**
 * 为音频添加水印
 * @param audioUri 原始音频 URI
 * @param watermarkPath 水印音频路径，默认为 '/audios/watermark.wav'
 * @returns 返回带水印的音频 Blob URL
 */
export async function addAudioWatermark(audioUri: string, watermarkPath = '/audios/watermark.wav'): Promise<string> {
  let audioBlob: Blob | null = null;
  let watermarkBlob: Blob | null = null;
  let concatenatedBlobUrl: string | null = null;

  try {
    // 并行获取原始音频和水印音频文件
    const [audioResponse, watermarkResponse] = await Promise.all([fetch(audioUri), fetch(watermarkPath)]);

    // 检查响应状态
    if (!audioResponse.ok) {
      throw new Error(`Failed to fetch audio: ${audioResponse.status} ${audioResponse.statusText}`);
    }
    if (!watermarkResponse.ok) {
      throw new Error(`Failed to fetch watermark: ${watermarkResponse.status} ${watermarkResponse.statusText}`);
    }

    audioBlob = await audioResponse.blob();
    watermarkBlob = await watermarkResponse.blob();

    const audioFile = new File([audioBlob], 'audio.wav', { type: 'audio/wav' });
    const watermarkFile = new File([watermarkBlob], 'watermark.wav', { type: 'audio/wav' });

    // 拼接音频
    const concatenatedBlob = await concatenateWavFiles(audioFile, watermarkFile);
    concatenatedBlobUrl = URL.createObjectURL(concatenatedBlob);

    return concatenatedBlobUrl;
  } catch (error) {
    console.error('Error adding watermark to audio:', error);

    // 清理可能创建的 Blob URL
    if (concatenatedBlobUrl) {
      URL.revokeObjectURL(concatenatedBlobUrl);
    }

    // 出错时返回原始音频
    return audioUri;
  } finally {
    // 清理临时引用
    audioBlob = null;
    watermarkBlob = null;

    // 清理音频资源
    await cleanup();
  }
}
